<template>
    <div id="app">
        <component :is="layout">
            <router-view></router-view>
        </component>
    </div>
</template>

<script>
const default_layout = 'blank-layout';

import MainLayout from "./layouts/MainLayout";
import BlankLayout from "./layouts/BlankLayout";
import { Locale } from "./modules/utils";

export default {
    name: "App",

    components: {
        MainLayout,
        BlankLayout,
    },

    computed: {
        layout: function() {
            return (this.$route.meta.layout || default_layout);
        },
    },

    beforeMount() {
        this.$i18n.locale = Locale.getFromCookie() || this.$i18n.locale;
    },

    created() {
        document.title = this.$t(this.$route.meta.title) || 'Application';
    },

    watch: {
        '$route' (to) {
            this.$store.commit("resetValidation");
            this.$store.commit("closeSnackbarMessage");

            document.title = this.$t(to.meta.title) || 'Application';
        }
    },
}
</script>

<style>
a {
    text-decoration: none;
}
</style>
